import React from 'react';
import { Grid, Button, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import {
  deleteFile,
  ownerLSCUploadPosition,
  uploadedFilesGrid,
} from '../../../styles';

//File upload component
const FileUpload = props => {
  const {
    displayFiles = [],
    setDisplayFiles = () => {},
    uploadedFiles = [],
    setUploadedFiles = () => {},
    errorMessage = '',
    setErrorMessage = () => {},
    removeDoc = () => {},
    marginLeft = '5rem',
    allowedFileNumber = 4,
    fetchedFiles = [],
    disabled = false,
    isOwnerLSC = false,
  } = props;
  const { t } = useTranslation();

  const allowedMaxFile = allowedFileNumber;
  const allowedFileSize = 10 * 1024 * 1024 * 1024; // 10 GB
  const allowedFileFormat = [
    'image/jpg', //.jpg
    'image/jpeg', //.jpeg
    'application/pdf', //.pdf
    'image/gif', //.gif
    'image/tiff', //.tiff
    'application/msaccess', //.mdb
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //.xlsx
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', //.pptx
    'application/vnd.ms-publisher', //File Extension: pub, Name: Microsoft Office Publisher Document
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //.docx
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12', //.pptm
    'application/vnd.ms-powerpoint', //.ppt  .pot  .pps  .ppa
    'application/msword', //.doc  .dot
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template', //.dotx
    'application/vnd.ms-word.document.macroEnabled.12', //.docm
    'application/vnd.ms-word.template.macroEnabled.12', //.dotm
    'application/vnd.ms-excel', //.xls .xlt  .xla
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template', //.xltx
    'application/vnd.ms-excel.sheet.macroEnabled.12', //.xlsm
    'application/vnd.ms-excel.template.macroEnabled.12', //.xltm
    'application/vnd.ms-excel.addin.macroEnabled.12', //.xlam
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12', //.xlsb
    'application/vnd.openxmlformats-officedocument.presentationml.template', //.potx
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow', //.ppsx
    'application/vnd.ms-powerpoint.addin.macroEnabled.12', //.ppam
    'application/vnd.ms-powerpoint.template.macroEnabled.12', //.potm
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12', //.ppsm
    'application/vnd.ms-access', //.mdb
    'image/png', //.png
    'message/rfc822', //.eml - for email saved from browser
    '.msg', //.msg - for email saved from outlook application
  ];
  const formatError = 'formatError';
  const maxCountError = 'maxCountError';
  const duplicateError = 'duplicateError';
  const fileSizeError = 'fileSizeError';

  //to check files are not same or not
  const isRepeatedFile = selectedFile =>
    [...displayFiles].filter(item => {
      return item === selectedFile.name;
    });

  //to handle upload functionality of file upload
  const handleUploadFiles = files => {
    const uploaded = [];
    let errorInFileUpload = false;
    files.some(file => {
      const getFileExtension = file.name.split('.');
      const fileExtension = getFileExtension.pop();

      uploaded.push(file);
      if (displayFiles.length + files.length > allowedMaxFile) {
        setErrorMessage(maxCountError);
        errorInFileUpload = true;
        return true;
      } else if (isRepeatedFile(file).length > 0) {
        setErrorMessage(duplicateError);
        errorInFileUpload = true;
        return true;
      } else if (file.size >= allowedFileSize) {
        setErrorMessage(fileSizeError);
        errorInFileUpload = true;
        return true;
      } else if (fileExtension === 'msg') {
        return false;
      } else if (!allowedFileFormat.includes(file.type)) {
        setErrorMessage(formatError);
        errorInFileUpload = true;
        return true;
      } else {
        return false;
      }
    });
    if (!errorInFileUpload) {
      setUploadedFiles([...uploadedFiles, ...uploaded]);
      uploaded.map(item => {
        return setDisplayFiles(prevState => [...prevState, item.name]);
      });
    }
  };

  //to handle the onChange of Upload Documents input fields
  const handleFileEvent = e => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    setErrorMessage('');
    handleUploadFiles(chosenFiles);
    return (e.target.value = '');
  };

  return (
    <Grid>
      {isOwnerLSC ? (
        <Grid>
          {errorMessage === maxCountError ? (
            <Tooltip
              title={t('maximum_allowed_number_of_files', {
                allowedMaxFile: allowedMaxFile,
              })}
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                  },
                },
              }}
            >
              <Typography noWrap width={350} sx={{ cursor: 'default' }}>
                {t('maximum_allowed_number_of_files', {
                  allowedMaxFile: allowedMaxFile,
                })}
              </Typography>
            </Tooltip>
          ) : errorMessage === formatError ? (
            <Tooltip
              title={t('allowed_file_type')}
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                  },
                },
              }}
            >
              <Typography noWrap width={350} sx={{ cursor: 'default' }}>
                {t('allowed_file_type')}
              </Typography>
            </Tooltip>
          ) : errorMessage === duplicateError ? (
            <Tooltip
              title={t('dupliacte_not_allowed')}
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                  },
                },
              }}
            >
              <Typography noWrap width={350} sx={{ cursor: 'default' }}>
                {t('dupliacte_not_allowed')}
              </Typography>
            </Tooltip>
          ) : errorMessage === fileSizeError ? (
            <Tooltip
              title={t('allowed_file_size')}
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                  },
                },
              }}
            >
              <Typography noWrap width={350} sx={{ cursor: 'default' }}>
                {t('allowed_file_size')}
              </Typography>
            </Tooltip>
          ) : null}
        </Grid>
      ) : null}
      <Grid style={isOwnerLSC ? ownerLSCUploadPosition : uploadedFilesGrid}>
        <Grid>
          <Button
            variant={disabled ? 'contained' : 'outlined'}
            style={{
              color: disabled ? 'GrayText' : 'black',
              border: disabled ? 'none' : '1.5px solid #0d6efd',
              marginLeft: marginLeft,
              textTransform: 'none',
            }}
            component="label"
            disabled={disabled}
          >
            {t('Upload_Documents')}
            <input
              type="file"
              name="file"
              hidden
              multiple
              accept={allowedFileFormat.toString()}
              onChange={handleFileEvent}
            />
          </Button>
        </Grid>
        {isOwnerLSC ? (
          <Grid>
            {displayFiles.length > 0 &&
              displayFiles.map((file, index) => {
                let showIcon = true;
                fetchedFiles.map(fetchedFile => {
                  if (fetchedFile === file) {
                    showIcon = false;
                  }
                  return showIcon;
                });
                return (
                  <Grid key={index} sx={{ display: 'flex' }}>
                    {showIcon && !disabled && (
                      <DeleteIcon
                        fontSize="small"
                        style={deleteFile}
                        onClick={event => removeDoc(event, file)}
                      />
                    )}
                    <Tooltip
                      title={file}
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontSize: '14px',
                          },
                        },
                      }}
                    >
                      <Typography noWrap width={200} sx={{ cursor: 'default' }}>
                        {file}
                      </Typography>
                    </Tooltip>
                  </Grid>
                );
              })}
          </Grid>
        ) : (
          <Grid>
            {errorMessage === maxCountError ? (
              <div>
                {t('maximum_allowed_number_of_files', {
                  allowedMaxFile: allowedMaxFile,
                })}
              </div>
            ) : errorMessage === formatError ? (
              <div>{t('allowed_file_type')}</div>
            ) : errorMessage === duplicateError ? (
              <div> {t('dupliacte_not_allowed')}</div>
            ) : errorMessage === fileSizeError ? (
              <div>{t('allowed_file_size')}</div>
            ) : null}
            {displayFiles.length > 0 &&
              displayFiles.map((file, index) => {
                let showIcon = true;
                fetchedFiles.map(fetchedFile => {
                  if (fetchedFile === file) {
                    showIcon = false;
                  }
                  return showIcon;
                });
                return (
                  <div key={index}>
                    {showIcon && !disabled && (
                      <DeleteIcon
                        fontSize="small"
                        style={deleteFile}
                        onClick={event => removeDoc(event, file)}
                      />
                    )}
                    {file}
                  </div>
                );
              })}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default FileUpload;
